<template>
    <el-container>
        <el-main>
            <el-card class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>审核 </span>
                    <div style="float: right;margin-top: -10px;margin-left: 10px">
                        <el-button @click="load" size="small" icon="el-icon-search" circle></el-button>
                    </div>
                    <div style="float: right;width: 200px;margin-top: -6px">
                        <el-input     size="small" v-model="pass" placeholder="请输入key"></el-input>
                    </div>
                </div>
                <el-table class="center"
                          v-loading="GeneratorsLoading"
                          stripe
                          :data="GeneratorsData"
                          style="width: 100%">
                    <el-table-column
                            label="id"
                            width="80">
                        <template slot-scope="scope">
                            {{scope.$index + 1}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="code"
                            label="code">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="name">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="type">
                    </el-table-column>
                    <el-table-column
                            prop="link"
                            label="link">
                    </el-table-column>
                    <el-table-column
                            prop="desc"
                            label="desc"
                            width="360">
                    </el-table-column>
                    <el-table-column
                            prop="wechat"
                            label="wechat">
                    </el-table-column>
                    <el-table-column
                            prop="date"
                            label="date">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="160">
                        <template slot-scope="scope">
                            <!--<el-button  type="text" size="small">查看</el-button>-->
                            <el-button
                                    @click="handleClick(scope.row,1)"
                                    size="mini">通过
                            </el-button>
                            <el-button
                                    size="mini"
                                    @click="handleClick(scope.row,2)"
                                    type="danger">拒绝
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-main>
    </el-container>
</template>


<script>
    import fhead from './fhead.vue';

    var load;

    export default {
        name: 'generators',
        components: {
            fhead
        },
        data() {
            return {
                GeneratorsLoading: true,
                GeneratorsData: [],
                sum: 0,
                pass:''
            }
        },
        methods: {
            handleClick(index,type){
                this.$ajax({
                    method: 'post',
                    url: 'https://api.rmbtrade.com/review',
                    data:{
                        "id":index._id,
                        "type":type,
                        "pass":this.pass
                    }
                }).then(response => {
                    this.load();
                });
            },
            load() {
                this.GeneratorsLoading = true;
                this.$ajax({
                    method: 'get',
                    url: 'https://api.rmbtrade.com/review?pass='+this.pass,
                }).then(response => {
                    this.GeneratorsData = response.list;
                    this.GeneratorsLoading = false;
                });
            }
        },
        created: function () {
        },
    }
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/review.vue